export default __webpack_public_path__ + "static/media/img-0606-liechtenstein-half-face.f3ae71e2.png";